import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckIcon, ArrowRightIcon } from "lucide-react";
import { painPoints } from "../data/landing";
export function PainPoints() {
  const [selected, setSelected] = useState<number[]>([]);
  const toggle = (i: number) => setSelected(prev => prev.includes(i) ? prev.filter(x => x !== i) : [...prev, i]);
  const count = selected.length;
  return <section className="bg-forest text-paper" data-id="element-221" data-mp="1xw6iowt3dqbd">
      <div className="mx-auto max-w-6xl px-5 py-12 md:px-8 md:py-24" data-id="element-222" data-mp="21z36d1xhocm6">
        <div className="grid gap-6 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20" data-id="element-223" data-mp="21x8knlee8gh1">
          <div data-id="element-224" data-mp="1o14sryqzsk7q">
            <p className="text-sm font-semibold text-gold" data-id="element-225" data-mp="1o1enfzmzffjr">¿Te pasa esto?</p>
            <h2 className="mt-2 font-display text-[28px] leading-tight md:mt-3 md:text-5xl" data-id="element-226" data-mp="1szg3ebp42yr0">
              Si recibís invitados en las fiestas, esto te suena familiar
            </h2>
            <p className="mt-3 text-sm text-paper/60 md:mt-5" data-id="element-227" data-mp="3nbmpw6ngh1ym">Tocá las que te pasan.</p>
          </div>
          <ul className="grid grid-cols-2 gap-2 md:gap-3" data-id="element-228" data-mp="1yzn53nbw7eho">
            {painPoints.map((p, i) => {
            const on = selected.includes(i);
            return <li key={p.title} data-id="element-229" data-mp="27tia8vd0l4xb" data-mpi={i}>
                  <button type="button" aria-pressed={on} onClick={() => toggle(i)} className={`flex h-full w-full gap-2.5 rounded-xl p-3 text-left ring-1 transition-[background-color,box-shadow,transform] duration-150 ease-out active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-gold md:p-4 ${on ? "bg-wine ring-wine" : "bg-paper/5 ring-paper/15 hover:bg-paper/10"}`} data-id="element-230" data-mp="27rp4dia86oqd">
                    <span className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full ring-1 transition-colors duration-150 ${on ? "bg-gold ring-gold" : "ring-paper/40"}`} data-id="element-231" data-mp="1k5qv7k03adsc">
                      {on && <CheckIcon className="h-3 w-3 text-forestDeep" aria-hidden data-id="element-232" data-mp="1t7hosarhao49" />}
                    </span>
                    <span data-id="element-233" data-mp="225tor3e8iy9d">
                      <span className="block text-[13px] font-semibold leading-snug md:text-base" data-id="element-234" data-mp="225ldth1oa30t">{p.title}</span>
                      <span className="mt-1 hidden text-sm leading-relaxed text-paper/65 md:block" data-id="element-235" data-mp="273v4pfgd6hgm">{p.text}</span>
                    </span>
                  </button>
                </li>;
          })}
          </ul>
        </div>
        <div className="mt-8 border-t border-paper/15 pt-6 text-center md:mt-14 md:pt-10" data-id="element-236" data-mp="1edwdbdep688s">
          <AnimatePresence mode="wait" initial={false} data-id="element-237" data-mp="1jd91q2l7vndh">
            {count === 0 ? <motion.p key="q" initial={{
            opacity: 0,
            y: 6
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -6
          }} transition={{
            duration: 0.18,
            ease: [0.23, 1, 0.32, 1]
          }} className="font-display text-2xl italic text-goldSoft md:text-4xl" data-id="element-238" data-mp="1o7d9go2b3zfm">
                ¿Cuántas fiestas más vas a improvisar en la cocina?
              </motion.p> : <motion.div key="a" initial={{
            opacity: 0,
            y: 6
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -6
          }} transition={{
            duration: 0.18,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col items-center gap-3" data-id="element-239" data-mp="e7148n033p25">
                <p className="font-display text-2xl text-goldSoft md:text-3xl" data-id="element-240" data-mp="ekxbb42b6vy">
                  Te identificaste con {count} de {painPoints.length}. El Megapack resuelve todas.
                </p>
                <a href="#precios" className="inline-flex items-center gap-2 rounded-full bg-gold px-5 py-2.5 text-sm font-semibold text-forestDeep transition-colors duration-150 hover:bg-goldSoft" data-id="element-241" data-mp="3mlsxlz04knl4">
                  Ver cómo lo resuelvo <ArrowRightIcon className="h-4 w-4" aria-hidden data-id="element-242" data-mp="1hkkvyj7hcwyl" />
                </a>
              </motion.div>}
          </AnimatePresence>
        </div>
      </div>
    </section>;
}